import AdminApi from '../../../services/api'
import swal from 'sweetalert2';
import session from '../../../services/session'

const AdminApiService = new AdminApi()


export default {
    data() {
        return {
            id: 0,
            model: {
                email: '',
                name: '',
                phone: '',
                surname: '',
                role: 'ROLE_USER',
                username: '',
                paidDate: null,
                expireDate: null,
                restOfTraining: 0,
                isAcceptTerms: false
            }
        }
    },
    methods: {
        update: update,
        clear: clear,
        resetPassword: resetPassword
    },
    beforeMount() {
        if(session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/home');
            return;
        }
        let _self = this;
        this.id = this.$route.query.id;
        AdminApiService.getUser(this.$route.query.id)
            .then((response) => {
                _self.model = response.data;
                _self.model.paidDate = this.$moment(new Date(_self.model.paidDate * 1000)).format('YYYY-MM-DD')
                _self.model.expireDate = this.$moment(new Date(_self.model.expireDate * 1000)).format('YYYY-MM-DD')
            })
            .catch(error => {

                swal('Greška', error.data.localized_error_message, 'error')
            })
    }
}

function clear() {
    this.model.email = '';
    this.model.name = '';
    this.model.phone = '';
    this.model.surname = '';
    this.model.role = 'ROLE_USER';
    this.model.username = '';
    this.model.paidDate = null;
    this.model.expireDate = null;
    this.model.restOfTraining = 0;
}

function update() {
    this.model.paidDate = this.model.paidDate + 'T00:00:00.000Z';
    this.model.expireDate = this.model.expireDate + 'T00:00:00.000Z';
    let id = this.id;
    AdminApiService.updateUser(this.model, id)
        .then((response) => {
            swal('Success', 'Korisnik ažuriran', 'success')
            this.$router.push('/users')
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function resetPassword() {
    let id = this.id;
    AdminApiService.resetUserPassword(id)
        .then((response) => {
            swal('Uspešno', 'Lozinka uspešno ażurirana', 'success')
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}


// WEBPACK FOOTER //
// ./src/components/Users/Edit/EditUser.js